import { toast } from 'react-toastify';

export function addNotification({ icon, msg, img }, time = 4) {
  toast(
    <div className='notic'>
      {icon && <i className={icon}></i>}
      {img && <img className='notipoke' alt='' src='https://i.imgur.com/9vjciKz.png' />}
      <strong>{msg}</strong>
    </div>,
    {
      autoClose: time * 1000,
      position: 'top-right',
    }
  );
}
  